import { useAuth } from "@/context/AuthContext";

export const FREE_MILESTONES = [1, 2];
export const FREE_MODULE_IDS = ["m-orientation", "m-service"];

export function useAccess() {
  const { user } = useAuth();
  const entitlements = user?.entitlements || [];
  const admin = user?.role === "admin";
  return {
    admin,
    entitlements,
    paidAcademy: admin || entitlements.includes("popup_profits"),
    hasCalculator: admin || entitlements.includes("event_calculator"),
  };
}
